import { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";

import { useAuth } from './../contexts/AuthContext';
import './AdminLayout.css';
import { useNavigate, Link } from 'react-router-dom'

import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import AppleIcon from '@mui/icons-material/Apple';
import GroupsIcon from '@mui/icons-material/Groups';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LockResetIcon from "@mui/icons-material/LockReset";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

export default function Sidebar({user}) {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', role: ['admin'] },
    { id: 'avaliacaoprojeto', label: 'Avaliação dos Projetos', icon: '📊', role: ['admin', 'avaliadorprojeto'] },
    { id: 'avaliacaodocumento', label: 'Avaliação dos Documentos', icon: '📊', role: ['admin', 'avaliadordocumento'] },
    { id: 'usuarioadmin', label: 'Criar Usuário', icon: '📊', role: ['admin'] },
    // { id: 'etapas', label: 'Etapas', icon: '📋' },
    // { id: 'escolaridades', label: 'Escolaridades', icon: '🎓' },
    // { id: 'eixos', label: 'Eixos', icon: '🎯' },
    // { id: 'cursos', label: 'Cursos', icon: '📚' },
    // { id: 'turmas', label: 'Turmas', icon: '👥' },
    { id: 'inscricoes', label: 'Inscrições', icon: '📝', role: ['admin'] } ,
    { id: 'eventos', label: 'Eventos', icon: '🏷️', role: ['admin'] },
    // { id: 'temas', label: 'Temas', icon: '⚙️' },
    // { id: 'tema-campos', label: 'Campos do Tema', icon: '⚙️' },
    { id: 'evento-campos', label: 'Campos do Evento', icon: '⚙️', role: ['admin'] },
    { id: 'arquivos', label: 'Arquivos', icon: '📁', role: ['admin'] },
  ];

  return (
    <>
      {/* Botão Hamburger */}
      <IconButton 
      sx={{
        position: "fixed",
        top: 70,
        left: 4,
        zIndex: 1100, 
        // background: "#fff",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        "&:hover": { background: "#f0f0f0" }
      }} onClick={() => setOpen(true)}>
        <MenuIcon fontSize="large" />
      </IconButton>

      {/* MENU */}
      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: 260,
            height: "100vh", // ocupa toda a tela
            display: "flex",
            flexDirection: "column",
            zIndex: 3000,
            backgroundColor: "#F5F5F5",
            color: "#222"
          }
        }}
      >
        {/* Cabeçalho do menu */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #ddd"
          }}
        >
          <h3 style={{ margin: 0 }}>Menu</h3>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>

        {/* Lista de itens */}
        <List onClick={() => {setOpen(false)}}>
          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/')}}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Início" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/formedital')}}>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText primary="Editais" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/formprodutor')}}>
              <ListItemIcon>
                <AgricultureIcon />
              </ListItemIcon>
              <ListItemText  primary="Fornecedores" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/formgrupoassociacao')}}>
              <ListItemIcon>
                <GroupsIcon />
              </ListItemIcon>
              <ListItemText  primary="Grupos/Associações" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/formalimento')}}>
              <ListItemIcon>
                <AppleIcon />
              </ListItemIcon>
              <ListItemText  primary="Gêneros Alimentícios" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/editaisprodutos')}}>
              <ListItemIcon>
                <FactCheckIcon />
              </ListItemIcon>
              <ListItemText primary="Editais x Produtos" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/relatorios')}}>
              <ListItemIcon>
                <AssessmentIcon />
              </ListItemIcon>
              <ListItemText primary="Relatórios" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/alterarsenhaprodutor')}}>
              <ListItemIcon>
                <LockResetIcon />
              </ListItemIcon>
              <ListItemText primary="Senha do Produtor" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => {navigate('/formusuarioadmin')}}>
              <ListItemIcon>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Usuários Administrativos" />
            </ListItemButton>
          </ListItem>
        </List>
        
      </Drawer>
    </>
  );
}
